import React from 'react';
import { FileIcon } from 'lucide-react';
export function EmptyState({
  icon = <FileIcon size={24} data-id="element-33" />,
  title = 'No items found',
  description = 'There are no items to display at the moment.',
  children
}) {
  return <div className="flex flex-col items-center justify-center py-12 px-4" data-id="element-34">
      <div className="bg-gray-100 p-4 rounded-full mb-4" data-id="element-35">{icon}</div>
      <h3 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-36">{title}</h3>
      <p className="text-gray-500 text-center mb-4" data-id="element-37">{description}</p>
      {children}
    </div>;
}